import React, { useEffect } from 'react';
import { ScheduleTable } from '../components/ScheduleTable';
import { LeadForm } from '../components/LeadForm';
import { CTABand } from '../components/CTABand';
export function Schedule() {
  useEffect(() => {
    document.title = 'Class Schedule | Storm Taekwondo';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-684">
      {/* Hero */}
      <section className="bg-ink py-20 text-center px-4" data-id="element-685">
        <h1 className="text-5xl md:text-6xl text-white mb-6" data-id="element-686">Class Schedule</h1>
        <p className="text-xl text-gray-warm max-w-2xl mx-auto" data-id="element-687">
          Classes available Monday through Saturday for all ages and experience
          levels.
        </p>
      </section>

      <section className="py-24" data-id="element-688">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-689">
          <div className="grid lg:grid-cols-3 gap-12 lg:gap-16" data-id="element-690">
            <div className="lg:col-span-2" data-id="element-691">
              <ScheduleTable data-id="element-692" />

              <div className="mt-12 bg-paper p-8 rounded-2xl border border-subtle-gray" data-id="element-693">
                <h3 className="text-2xl text-ink mb-4" data-id="element-694">Important Notes</h3>
                <ul className="flex flex-col gap-3 text-gray-warm" data-id="element-695">
                  <li data-id="element-696">
                    • Please arrive 10 minutes before your scheduled class time.
                  </li>
                  <li data-id="element-697">
                    • Trial students should wear comfortable athletic clothing
                    (no zippers or buttons).
                  </li>
                  <li data-id="element-698">• Bring a water bottle.</li>
                  <li data-id="element-699">
                    • Class times are subject to change. We will confirm your
                    exact class time when you claim your free week.
                  </li>
                </ul>
              </div>
            </div>

            <div className="lg:col-span-1" data-id="element-700">
              <div className="sticky top-28" data-id="element-701">
                <div className="bg-paper p-8 rounded-2xl shadow-xl border border-subtle-gray" data-id="element-702">
                  <h3 className="text-2xl text-ink text-center mb-2" data-id="element-703">
                    Claim Your Free Week
                  </h3>
                  <p className="text-center text-gray-warm mb-6 text-sm" data-id="element-704">
                    Fill out the form and we'll contact you to schedule your
                    first class.
                  </p>
                  <LeadForm data-id="element-705" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTABand headline="Questions About the Schedule?" copy="Give us a call and we'll help you find the perfect class time for your family." data-id="element-706" />
    </div>;
}